export default [
  {
    label: 'Dashboard',
    to: { name: 'home' },
    icon: 'fas fa-fw fa-tachometer-alt',
  },
  {
    label: 'Produtos',
    icon: 'fas fa-fw fa-shapes',
    subItems: [
      {
        label: 'Revistas',
        to: { name: 'magazines.list' },
        icon: 'fas fa-fw fa-book-open',
      },
      {
        label: 'Livros',
        to: { name: 'books.list' },
        icon: 'fas fa-fw fa-book',
      },
      {
        label: 'Videos',
        to: { name: 'videos.list' },
        icon: 'fas fa-fw fa-video',
      },
      {
        label: 'Cursos',
        to: { name: 'courses.list' },
        icon: 'fas fa-fw fa-graduation-cap',
      },
      {
        label: 'Divulgações',
        to: { name: 'divulgations.list' },
        icon: 'fas fa-fw fa-bullhorn',
      },
    ],
  },
  {
    label: 'Usuários',
    icon: 'fas fa-fw fa-users',
    subItems: [
      {
        label: 'Administradores',
        to: { name: 'users.admins.list' },
        icon: 'fas fa-fw fa-users-cog',
      },
      {
        label: 'Usuários comuns',
        to: { name: 'users.commons.list' },
        icon: 'fas fa-fw fa-users',
      },
    ],
  },
  {
    label: 'Afiliados',
    icon: 'fas fa-fw fa-handshake',
    subItems: [
      {
        label: 'Solicitações',
        to: { name: 'filiations.requests.list' },
        icon: 'fas fa-fw fa-clipboard-list',
      },
      {
        label: 'Listar',
        to: { name: 'filiations.list' },
        icon: 'fas fa-fw fa-list',
      },
      {
        label: 'Balanços',
        to: { name: 'filiations.balances.list' },
        icon: 'fas fa-fw fa-balance-scale-right',
      },
    ],
  },
  {
    label: 'Transferências',
    to: { name: 'transfers.list' },
    icon: 'fas fa-fw fa-exchange-alt',
  },
  {
    label: 'Autores',
    to: { name: 'authors.list' },
    icon: 'fas fa-fw fa-user-edit',
  },
  {
    label: 'Coleções',
    to: { name: 'collections.list' },
    icon: 'fas fa-fw fa-boxes',
  },
  {
    label: 'Planos',
    to: { name: 'plans.list' },
    icon: 'fas fa-fw fa-shapes',
  },
  {
    label: 'Assinaturas',
    to: { name: 'subscriptions.list' },
    icon: 'fas fa-fw fa-dollar-sign',
  },
  {
    label: 'Compras',
    to: { name: 'purchases.list' },
    icon: 'fas fa-fw fa-shopping-cart',
  },
  {
    label: 'Cupons',
    to: { name: 'coupons.list' },
    icon: 'fas fa-fw fa-ticket-alt',
  },
  {
    label: 'Importar CSV',
    to: { name: 'import-csvs.list' },
    icon: 'fas fa-file-csv',
  },
  {
    label: 'Banners',
    to: { name: 'banners.list' },
    icon: 'far fa-image',
  },
  {
    label: 'Relatórios em CSV',
    to: { name: 'csv-reports.reports' },
    icon: 'fas fa-file-csv',
  },
  {
    label: 'Gerar XML',
    to: { name: 'xml-reports.reports' },
    icon: 'fas fa-file-code',
  },
  {
    label: 'Parâmetros',
    to: { name: 'systemParameters' },
    icon: 'fas fa-fw fa-cogs',
  },
  {
    label: 'Termos de uso',
    to: { name: 'terms.list' },
    icon: 'fas fa-fw fa-file-alt',
  },
]
